import { ChangeDetectorRef, Component, computed, EventEmitter, inject, Inject, Input, OnInit, Output, TemplateRef, ViewChild } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap/modal";
import { DomSanitizer } from "@angular/platform-browser";
import { VersandUI } from "../../../Api/DcoApi/Versand/VersandUI";
import { RestClient } from "../../../Api/DcoApi/Client/RestClient";
import { EmailDialog } from "./EmailDialog";
import {VersandService} from '../../Services/VersandService';


@Component({
  imports: [
    CommonModule,
    FormsModule
  ],
  selector: 'VersandInfoControll',
  templateUrl: './VersandInfoControll.html',
  standalone: true,
  styleUrl: './VersandInfoControll.css'
})
export class VersandInfoControll {
  @Input() Versand: VersandUI = {} as VersandUI;
  Client: RestClient = new RestClient();
  @Output() Reload = new EventEmitter<VersandUI>();

  private modalService = inject(NgbModal);
  VersandService : VersandService = inject(VersandService);
  async InitTracking() {
    this.Versand = await this.VersandService.InitTracking(this.Versand.key) ?? this.Versand;
    this.Reload.emit(this.Versand);
  }

  get IsNotUnderway(): boolean {

    return this.Versand && this.Versand.status == 1;
  }

  get hasTracking(): boolean {
    return this.Versand && this.Versand.trackingnummer != null && this.Versand.trackingnummer != '';
  }

  async openSendDialog(){
    await this.VersandService.openSendDialog(this.Versand.trackingnummer, '')
    this.Reload.emit(this.Versand);
  }

}
